import {useEffect} from 'react'
import {useSearchParams, useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const useGetEventParticipantListNotJoined = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const {idx} = useParams()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		let path = `/admin/event/${idx}/not-joined/list?page=${page}`

		if (search) path += `&search=${search}`
		fetchRequest('GET', path)
	}, [page, search])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetEventParticipantListNotJoined
